import * as Sentry from '@sentry/browser'
import PropTypes from 'prop-types'
import React from 'react'
import { ErrorMessage } from 'components'

class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = { eventId: null }
  }

  state = {}

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      scope.setExtras({ ...errorInfo })
      const eventId = Sentry.captureException(error)

      this.setState({ eventId })
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <ErrorMessage
            src={`${process.env.REACT_APP_ASSETS_URL}/static/assets/images/what.svg`}
            title='Ops! Ocorreu um erro. Caso o erro persista, entre em contato com o suporte.'
          />
          <button onClick={() => Sentry.showReportDialog({ eventId: this.state.eventId })}>
            Reportar Problema
          </button>
        </>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
